import { ProfileInput } from "components/ProfileInput";
import React, { useEffect, useState } from "react";
import { MdEdit } from "react-icons/md";
import Modal from "react-modal";
import { useNotifications } from "reapop";
import "./style.scss";

type Props = {
  title: string;
  isAllowed: boolean;
  category_list: string[];
  data: string;
  onSelect: (val: string) => void;
  updateData: (val: string) => void;
};

export const EmailSelect: React.FC<Props> = ({
  title,
  isAllowed,
  category_list,
  data,
  onSelect,
  updateData,
}) => {
  const { notify } = useNotifications();
  const [selectedValue, setSelectedValue] = useState<string[]>([]);
  const [updatedSelectedValue, setUpdatedSelectedValue] = useState<string>('');
  const [showModal, setShowModal] = useState(false);

  const validateEmail = (value: string) => {
    const re = /\S+@\S+\.\S+/;
		let error = "";

    if (value !== "" && value.toLowerCase() !== 'null' && value.toLowerCase() !== 'unknown' && !re.test(value)) {
      error = "Invalid email address. Please check you input";
    }
		
		return error;
	};

  const handleUpdateSelectedData = (val) => {
    setSelectedValue([val]);
    onSelect(val);
  };

  const handleUpdateInputData = (val) => {
    setUpdatedSelectedValue(val);
  };

  const handleOpenModal = () => {
    setShowModal(true);
    setUpdatedSelectedValue(selectedValue[0].split(':')[0]);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleSaveModal = () => {
    const value = `${updatedSelectedValue}:${selectedValue[0].split(':')[1]}`;
    const error = validateEmail(updatedSelectedValue);

    if (!error) {
      updateData(value);
      setSelectedValue([value]);
      handleCloseModal();
    } else {
      notify(error, "error", {
        title: "Email address",
      });
    }
  };

  useEffect(() => {
    if (data) {
      setSelectedValue([data]);
    }
  }, [data]);

  return (
    <>
      <div className="email-select-container">
        <span>{title}</span>
        <div
          className={
            isAllowed
              ? "advance-select"
              : "advance-select advance-select-disabled"
          }
        >
          <div>
            <select
              value={selectedValue}
              onChange={(e: any) => handleUpdateSelectedData(e.target.value)}
              disabled={!isAllowed}
              multiple
            >
              {category_list.map((value, index) => (
                <option key={index} value={`${value}:${index}`}>
                  {value || 'N/A'}
                </option>
              ))}
            </select>
          </div>
          <div>
            <button onClick={handleOpenModal} disabled={selectedValue.length === 0 || !isAllowed}>
              <MdEdit />
            </button>
          </div>
        </div>
      </div>

      <Modal isOpen={showModal} ariaHideApp={false} style={{
        content: {
          width: '240px',
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
        }
      }}>
        <ProfileInput type="email" isAllowed={true} data={updatedSelectedValue} updateData={handleUpdateInputData}/>
        <div className="modal-footer">
          <button className="profile-button-back" onClick={handleCloseModal}>Close</button>
          <button className="profile-button-update" onClick={handleSaveModal}>Done</button>
        </div>
      </Modal>
    </>
  );
};
